'use client';

import Link from 'next/link';
import { useRouter } from 'next/navigation';
import { useTranslations } from 'next-intl';
import { Button } from '@/components/ui/button';
import { logger } from '@/lib/clientSideLogger';
interface ErrorProps {
  error: Error & { digest?: string };
  reset: () => void;
}

export default function Error({ error, reset }: ErrorProps) {
  const t = useTranslations('Error');
  const router = useRouter();

  logger('error', error);
  return (
    <div className='flex min-h-[50vh] w-full flex-col items-center justify-center p-4'>
      <div className='space-y-4 text-center'>
        <h2 className='text-2xl font-bold'>{t('title')}</h2>
        <p className='text-muted-foreground'>{error.message || t('message')}</p>
        <p className='text-muted-foreground text-sm'>
          {t('contact')}
          <Link href='mailto:info@findhaven.org' className='block underline'>
            info@findhaven.org
          </Link>
        </p>
        <div className='flex justify-center gap-4 [&>*]:max-w-[200px]'>
          <Button onClick={reset} className='mt-4 flex-1'>
            {t('tryAgain')}
          </Button>
          <Button
            variant='outline'
            className='mt-4 flex-1'
            onClick={() => router.push('/')}
          >
            {t('goToHome')}
          </Button>
        </div>
      </div>
    </div>
  );
}
